module.exports = __webpack_public_path__ + "front/img/logo.b593d820.png";